import { useState, useEffect } from 'react';
import api from '../../../../data/api';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../../../../data/atoms/utilsAtoms';

export const useVideoData = ({
	categoryId,
	currentPage,
	itemsPerPage,
	selectedTags,
	selectedDurations,
	selectedLevels,
	selectedInstructors,
	selectedProducts,
	sortby
}) => {
	const [responseData, setResponseData] = useState([]);
	const [totVideos, setTotVideos] = useState('');
	const userData = useAtomValue(userInfoAtom);
	const startIndex = (currentPage - 1) * itemsPerPage;

	// Fetch videos based on filters
	useEffect(() => {
		fetchData();
	}, [
		currentPage,
		itemsPerPage,
		categoryId,
		startIndex,
		selectedTags,
		selectedDurations,
		selectedLevels,
		selectedInstructors,
		selectedProducts,
		sortby
	]);

	const fetchData = async () => {
		try {
			const userId = userData.user?.userId ?? userData.user?._id;
			const endIndex = startIndex + itemsPerPage - 1;
			const selectedTagsIds = selectedTags?.map(tag => tag).join(',');
			const durations = selectedDurations?.map(duration => duration).join(',');
			const levels = selectedLevels?.map(level => level).join(',');

			const response = await api.getSingleFilteredVideos({
				startIndex,
				endIndex,
				selectedTags: selectedTagsIds,
				selectedDurations: durations,
				selectedLevels: levels,
				sortby: sortby || 'latest',
				selectedInstructors,
				selectedProducts,
				userId,
				categoryId
			});

			setTotVideos(Math.ceil(response.data.libraryVideosData[0].totalRecords / itemsPerPage));
			setResponseData(response.data.libraryVideosData);
		} catch (error) {
			console.error('Error fetching data: ', error);
		}
	};

	const handleShuffle = categoryId => {
		setResponseData(prevData => {
			// Find the category to shuffle
			const shuffledCategory = prevData.find(category => category._id === categoryId);

			// Shuffle the videos in the category
			if (shuffledCategory) {
				shuffledCategory.videos = shuffleArray(shuffledCategory.videos);
			}

			return [...prevData];
		});
	};

	const shuffleArray = array => {
		const shuffledArray = [...array];
		for (let i = shuffledArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
		}
		return shuffledArray;
	};

	return {
		responseData,
		setResponseData,
		totVideos,
		handleShuffle
	};
};
